export default __webpack_public_path__ + "static/axes-e0f45042dbf6bd83c422d748d18b7ce0.png";